'use client';

import React, { ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { AllFathomEventNames } from '@/lib/fathom/fathom-events';
import { trackFathomEvent } from '@/lib/fathom/trackFathomEvent';

type CardProps = {
  variant: 'dark' | 'light';
  children: React.ReactNode;
  className?: string;
  hasHoverState?: boolean;
  linkUrl?: string;
  target?: ComponentPropsWithoutRef<'a'>['target'];
  fathomEvent?: AllFathomEventNames;
};

// TODO: Use this component on Develocity page
export function Card({ variant, children, className, linkUrl, hasHoverState, target, fathomEvent }: CardProps) {
  const classes = clsx(className, {
    'dark-background text-white': variant === 'dark',
    'bg-light-background text-gray-3': variant === 'light',
    'hover:card-shadow-hover group transition-all duration-300': hasHoverState,
  });

  const handleClick = () => {
    if (fathomEvent) {
      trackFathomEvent(fathomEvent);
    }
  };

  if (linkUrl) {
    return (
      <Link
        href={linkUrl}
        onClick={handleClick}
        {...(target && { target })}
        className={`${classes} card-shadow group flex flex-col rounded-3xl p-8 md:p-10 lg:rounded-5xl`}
      >
        {children}
      </Link>
    );
  }

  return (
    <div className={`${classes} card-shadow flex flex-col rounded-3xl p-8 md:p-10 lg:rounded-5xl`}>{children}</div>
  );
}
